module.exports = __webpack_public_path__ + "img/edge_step_2.e8e1d0f8.jpg";